// extracted by mini-css-extract-plugin
module.exports = {"modal":"NewsEditor_modal__1Ra-H","buttons":"NewsEditor_buttons__1McZz"};